// extracted by mini-css-extract-plugin
export var active = "nav-items-module--active--Yx7-E";
export var item = "nav-items-module--item--fsXO5";